export const normalizeBarcode = (value) => String(value || "").trim().replace(/\s+/g, "").toUpperCase();

export const isValidGtinCheckDigit = (value) => {
  const barcode = normalizeBarcode(value);
  if (!/^\d+$/.test(barcode) || ![8, 12, 13, 14].includes(barcode.length)) return false;

  const checkDigit = Number(barcode[barcode.length - 1]);
  const body = barcode.slice(0, -1);
  let sum = 0;

  for (let index = body.length - 1, position = 0; index >= 0; index -= 1, position += 1) {
    const digit = Number(body[index]);
    sum += digit * (position % 2 === 0 ? 3 : 1);
  }

  const expected = (10 - (sum % 10)) % 10;
  return expected === checkDigit;
};

export const getBarcodeValidation = (value) => {
  const barcode = normalizeBarcode(value);
  const numeric = /^\d+$/.test(barcode);
  const validLength = [8, 12, 13, 14].includes(barcode.length);
  const validCheckDigit = isValidGtinCheckDigit(barcode);

  return {
    barcode,
    numeric,
    validLength,
    validCheckDigit,
    isValidGs1Format: numeric && validLength && validCheckDigit,
  };
};
